/* ============ Shop / collection page ============ */
gsap.registerPlugin(ScrollTrigger);
(function shop(){
  const $=s=>document.querySelector(s);
  if(!$('#shGrid')||!window.OSO_PRODUCTS) return;
  if(window.osoAmbient) osoAmbient({sky:true});
  const rup=n=>'₹'+n.toLocaleString('en-IN');
  const heart='<svg viewBox="0 0 24 24"><path d="M12 20s-7-4.6-7-10a3.8 3.8 0 0 1 7-1.6A3.8 3.8 0 0 1 19 10c0 5.4-7 10-7 10Z"/></svg>';

  $('#shCols').innerHTML=OSO_COLORS.map(c=>`<button class="sh-cf" style="--c:${c[0]}" data-c="${c[0]}" title="${c[1]}" aria-label="${c[1]}"></button>`).join('');

  /* one card per design, with the colourway picker on the card, as designed */
  const state=new Map(OSO_PRODUCTS.map(p=>[p.id,p.color]));
  const card=p=>{const c=state.get(p.id);
    return `<a class="sh-card" href="/pages/product?id=${p.id}&c=${c.slice(1)}" data-print="${p.print}" data-id="${p.id}">
      <button class="sh-fav" data-fav aria-label="Save">${heart}</button>
      <div class="sh-img">${shopTee(c,p.print)}<button class="sh-qv" data-qv aria-label="Quick view">Quick view</button></div>
      <div class="sh-body">
        <div class="sh-sw">${OSO_productColors(p).map(x=>`<button class="sh-s${x[0]===c?' on':''}" style="--c:${x[0]}" data-c="${x[0]}" data-n="${x[1]}" aria-label="${x[1]}"></button>`).join('')}</div>
        <div class="sh-name">${p.name} <span class="sh-cn">${OSO_colorName(c)}</span></div>
        <div class="sh-row"><span class="sh-price">${rup(p.price)}</span></div>
      </div></a>`;};

  $('#shGrid').innerHTML=OSO_PRODUCTS.map(card).join('');
  const syncFavs=()=>document.querySelectorAll('.sh-card').forEach(c=>{
    const f=c.querySelector('.sh-fav'); if(f) f.classList.toggle('on',!!window.OSO_STORE&&OSO_STORE.inWishlist(c.dataset.id,state.get(c.dataset.id)));});
  syncFavs(); window.addEventListener('oso:store',syncFavs);

  const bt=$('#shBtees'); if(bt) bt.innerHTML=OSO_PRODUCTS.map(p=>shopTee(p.color,p.print)).join('');

  function swapCard(cardEl,hex,name){
    const p=OSO_findProduct(cardEl.dataset.id);
    state.set(p.id,hex);
    cardEl.querySelectorAll('.sh-s').forEach(x=>x.classList.toggle('on',x.dataset.c===hex));
    cardEl.querySelector('.sh-cn').textContent=name||OSO_colorName(hex);
    cardEl.href=`/pages/product?id=${p.id}&c=${hex.slice(1)}`;
    const img=cardEl.querySelector('.sh-img'), qv=img.querySelector('.sh-qv');
    img.innerHTML=shopTee(hex,p.print); if(qv) img.appendChild(qv);
    const t=img.querySelector('.tee-img');
    if(t) gsap.fromTo(t,{scale:1.06,autoAlpha:.3},{scale:1,autoAlpha:1,duration:.4,ease:'power2.out'});
    syncFavs();
  }

  $('#shGrid').addEventListener('click',e=>{
    const c=e.target.closest('.sh-card'); if(!c) return;
    const qb=e.target.closest('[data-qv]');
    if(qb){e.preventDefault();e.stopPropagation();window.osoQuickView&&osoQuickView(c.dataset.id,state.get(c.dataset.id));return;}
    const fb=e.target.closest('[data-fav]');
    if(fb){e.preventDefault();e.stopPropagation();
      if(window.OSO_STORE)OSO_STORE.toggleWishlist(c.dataset.id,state.get(c.dataset.id));
      gsap.fromTo(fb,{scale:.7},{scale:1,duration:.4,ease:'back.out(3)'});return;}
    const sw=e.target.closest('.sh-s'); if(!sw) return;
    e.preventDefault();e.stopPropagation();
    swapCard(c,sw.dataset.c,sw.dataset.n);
  });

  /* filters, design tabs and colour chips combine */
  let tab='all', colour=null;
  const madeIn=(p,hex)=>OSO_productColors(p).some(x=>x[0]===hex);
  function applyFilters(){
    let shown=0;
    document.querySelectorAll('.sh-card').forEach(c=>{
      /* a design not made in the chosen shade drops out, rather than showing
         the wrong photograph under the wrong colour name */
      const show=(tab==='all'||c.dataset.id===tab)&&(!colour||madeIn(OSO_findProduct(c.dataset.id),colour));
      if(show) shown++;
      c.style.display=show?'':'none';
      if(show) gsap.fromTo(c,{autoAlpha:.2,y:10},{autoAlpha:1,y:0,duration:.35,ease:'power2.out'});
    });
    const cnt=$('#shCount'); if(cnt) cnt.textContent=shown+(shown===1?' design':' designs');
    const none=$('#shNone'); if(none) none.hidden=shown>0;
  }
  /* picking a shade recolours the wall, and hides anything not made in it */
  $('#shCols').addEventListener('click',e=>{const b=e.target.closest('.sh-cf'); if(!b) return;
    const on=!b.classList.contains('on');
    document.querySelectorAll('#shCols .sh-cf').forEach(x=>x.classList.remove('on'));
    colour=null;
    if(on){b.classList.add('on'); colour=b.dataset.c;
      document.querySelectorAll('.sh-card').forEach(c=>{
        if(madeIn(OSO_findProduct(c.dataset.id),colour)) swapCard(c,colour,b.title);});}
    applyFilters();});
  gsap.utils.toArray('.sh-tab').forEach(t=>t.addEventListener('click',()=>{
    document.querySelectorAll('.sh-tab').forEach(x=>x.classList.toggle('on',x===t));
    tab=t.dataset.id||'all'; applyFilters();}));
  applyFilters();

  // build-a-set tile opens the real builder. It is the homepage's tile now, which is a
  // div rather than a link, so the whole banner is the click target.
  const bset=document.querySelector('.sh-bundle .feat-bundle');
  if(bset) bset.addEventListener('click',()=>location.href='/pages/build');

  /* the peek bear injects an extra child into the grid, which breaks the
     :last-child rule that centres a lone third card. Desktop only, same as the homepage. */
  if(window.osoPeek) osoPeek('#shGrid',{width:92});

  // hero intro
  gsap.timeline({defaults:{ease:'power3.out'},delay:.15})
    .from('.sh-hero .kick',{y:18,autoAlpha:0,duration:.6})
    .from('.sh-hero h1',{y:30,autoAlpha:0,duration:.8},'-=.4')
    .from('.sh-bar',{y:14,autoAlpha:0,duration:.6},'-=.45');

  // reveal cards + bundle on scroll
  gsap.set('.sh-card',{y:48,scale:.96});
  gsap.to('.sh-card',{opacity:1,y:0,scale:1,duration:.7,stagger:.12,ease:'power3.out',scrollTrigger:{trigger:'#shGrid',start:'top 88%',once:true}});
  gsap.from('.sh-bundle',{y:44,autoAlpha:0,duration:.8,ease:'power2.out',scrollTrigger:{trigger:'.sh-bundle',start:'top 86%',once:true}});
})();
